import apiClient from './client'
import type { Event, CreateEventRequest, UpdateEventRequest, EventParticipant, UpdateParticipantRequest } from '../../../shared/src/types/event'

export type DesktopEvent = Event & { participants_count?: number }
export type { CreateEventRequest, UpdateEventRequest, UpdateParticipantRequest, EventParticipant } from '../../../shared/src/types/event'
export { EVENT_TYPE_LABELS, PARTICIPATION_STATUS_LABELS, PARTICIPANT_PAYMENT_LABELS } from '../../../shared/src/types/event'

// Keep the assistant argument on existing methods for CalendarPage callers.
export const eventsApi = {
  getByAssistantId: async (assistantId: string): Promise<DesktopEvent[]> => {
    const { data } = await apiClient.get(`/assistants/${assistantId}/events`)
    return (data ?? []).map((event: DesktopEvent) => ({ ...event, participants_count: event.participant_count ?? event.participants_count }))
  },
  getUpcoming: async (assistantId: string): Promise<DesktopEvent[]> => {
    const { data } = await apiClient.get(`/assistants/${assistantId}/events/upcoming`)
    return data ?? []
  },
  create: async (assistantId: string, req: CreateEventRequest): Promise<DesktopEvent> => {
    const { data } = await apiClient.post(`/assistants/${assistantId}/events`, req)
    return data
  },
  getById: async (_assistantId: string, id: string): Promise<DesktopEvent> => {
    const { data } = await apiClient.get(`/events/${id}`)
    return { ...data, participants_count: data.participant_count ?? data.participants_count }
  },
  update: async (_assistantId: string, id: string, req: UpdateEventRequest): Promise<DesktopEvent> => {
    const { data } = await apiClient.put(`/events/${id}`, req)
    return data
  },
  delete: async (_assistantId: string, id: string): Promise<void> => {
    await apiClient.delete(`/events/${id}`)
  },
  getParticipants: async (_assistantId: string, eventId: string): Promise<EventParticipant[]> => {
    const { data } = await apiClient.get(`/events/${eventId}/participants`)
    return data ?? []
  },
  addParticipant: async (_assistantId: string, eventId: string, athleteId: string): Promise<void> => {
    await apiClient.post(`/events/${eventId}/participants`, { athlete_id: athleteId })
  },
  updateParticipant: async (eventId: string, athleteId: string, req: UpdateParticipantRequest): Promise<void> => {
    await apiClient.patch(`/events/${eventId}/participants/${athleteId}`, req)
  },
  removeParticipant: async (_assistantId: string, eventId: string, athleteId: string): Promise<void> => {
    await apiClient.delete(`/events/${eventId}/participants/${athleteId}`)
  },
}
